/* eslint-disable @typescript-eslint/no-explicit-any */

const USDTIcon = ({ props }: any) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.0127 9.87935C10.7258 9.87935 11.0454 9.86055 11.1073 9.85598L11.1053 9.85547C13.2929 9.75997 14.9247 9.38404 14.9247 8.93496C14.9247 8.48588 13.2924 8.10995 11.1053 8.01394V9.48209C11.0439 9.48768 10.7031 9.51562 10.0225 9.51562C9.45538 9.51562 9.04497 9.49174 8.90164 9.48158V8.01292C6.70988 8.10944 5.07392 8.48486 5.07392 8.93496C5.07392 9.38506 6.70988 9.76098 8.90164 9.85598C9.04291 9.86259 9.44558 9.87935 10.0127 9.87935Z"
            fill="#50AF95"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.26312 9.1778L4.45409 2.57367C4.46453 2.55143 4.48129 2.53264 4.50233 2.51957C4.52337 2.5065 4.5478 2.49971 4.57267 2.50001H15.4284C15.4531 2.49995 15.4774 2.50691 15.4982 2.52006C15.5191 2.53321 15.5356 2.552 15.5459 2.57418L18.7369 9.17831C18.749 9.20288 18.7529 9.23062 18.7479 9.2575C18.7429 9.28437 18.7292 9.30896 18.709 9.32767L10.091 17.464C10.0665 17.4871 10.0339 17.5 10 17.5C9.96608 17.5 9.93348 17.4871 9.909 17.464L1.29096 9.32716C1.27075 9.30845 1.25715 9.28386 1.25214 9.25699C1.24713 9.23011 1.25098 9.20237 1.26312 9.1778ZM11.1073 6.54782V7.86204C13.5834 7.97487 15.4439 8.45798 15.4439 9.03758C15.4439 9.61722 13.5816 10.1008 11.1068 10.2131V14.426H8.90112V10.2146C6.42063 10.1019 4.55524 9.61823 4.55524 9.03809C4.55524 8.45794 6.42063 7.9738 8.90112 7.86153V6.54782H5.84936V4.54372H14.1596V6.54782H11.1073Z"
            fill="#50AF95"
        />
    </svg>
)
export default USDTIcon
